/*@ngInject*/
const UserStateModel = function ($rootScope, $state, coreConstant) {

    let stateModelStorage,
        userId,
        userType,
        userForm,
        isVisibleForChat;

    this.init = function () {
        stateModelStorage = {};
        userId = null;
        userType = null;
        userForm = null;
        isVisibleForChat = true;
    };

    this.setVisibleForChat = function (isVisible) {
        isVisibleForChat = isVisible;
        $rootScope.$broadcast(coreConstant.event.CHAT_VISIBILITY_CHANGED, isVisibleForChat);
    };

    this.isVisibleForChat = function () {
        return isVisibleForChat;
    };

    this.saveViewState = function (stateName, stateModel) {
        stateModelStorage[stateName] = _.cloneDeep(stateModel);
    };

    this.restoreViewState = function (stateName, viewModel) {
        let previousState = stateModelStorage[stateName];

            if(previousState) {
                return _.merge(viewModel, previousState);
            }
        };

    this.getPreviousViewState = function (stateName) {
        return stateModelStorage[stateName];
    };

    this.savePreviousUser = function (id, type, formId) {
        userId = id;
        userType = type;
        userForm = formId;
    };

    this.getPreviousUser = function () {
        return {
            userId: userId,
            userType: userType,
            formId: userForm
        };
    };

    this.hasPreviousUser = function () {
        return userId !== null;
    };

    this.resetPreviousUser = function () {
        userId = null;
        userType = null;
        userForm = null;
        delete stateModelStorage[$state.name];
    };

    this.init();
};

angular.module('umCore')
    .service('userStateModel', UserStateModel);
